import { ActualApi } from './../../shared/sdk-budget/services/custom/Actual';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BudgetApi } from '../../shared/sdk-budget';
import * as moment from 'moment/moment';
import { Events } from 'ionic-angular';
import { LoopBackAuth as LoopBackAuthBudget } from './../../shared/sdk-budget/services/core/auth.service';

/*
  Generated class for the SfBudgetProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SfBudgetProvider {
  private syncBuffer: any[] = new Array();
  private _data: any = new Object();
  public get data() {
    return this._data;
  }
  private _typeList: any[];

  public month: any;
  public year: any;
  public monthyear: any;
  dataList = { projections: [], actuals: [] };

  constructor(
    public http: HttpClient,
    public budgetApi: BudgetApi,
    public events: Events,
    public authBudget: LoopBackAuthBudget,
    public actualApi: ActualApi
  ) {

    this.events.subscribe('BUDGET:LOADBUDGET', val => {
      this.month = val.month;
      this.year = val.year
      this.monthyear = this.month + this.year;
      // this.ionViewDidLoad();
      this.getProjections(this.month, this.year)
      this.getActualGroupByDate(this.month, this.year)
      this.getActualGroupByCategory(this.month, this.year)
    });
    console.log('Hello SfBudgetProvider Provider');

    // persistent data
    /*
    - this month
    - next month
    */
    // temporary data
    /*
    - prev months
    */

    // #region: LAOD_INITIAL_DATA
    console.log('should load initial data here and now..');
    this._typeList = [
      {
        name: 'expense',
        id: BudgetType.EXPENSE
      },
      {
        name: 'income',
        id: BudgetType.INCOME
      }
    ];

    this._data = <any>{
      wallet: [
        {
          name: 'cash',
          balance: 100000
        },
        {
          name: 'BCA',
          balance: 2450000.46
        },
        {
          name: 'mandiri',
          balance: 49000
        },
        {
          name: 'jenius',
          balance: 400000
        },
        {
          name: 'Permata',
          balance: 250000
        }
      ],
      monthly: {
        month0819: {
          actuals: [
            {
              date: new Date('2018-09-01'),
              list: [
                {
                  isIncome: true,
                  category: 'salary',
                  amount: 4500000,
                  label: 'gajian',
                  wallet: 'bca'
                },
                {
                  isIncome: false,
                  category: 'grocery',
                  amount: 582400,
                  label: 'belanja bulanan',
                  wallet: 'bca'
                }
              ]
            },
            {
              date: new Date('2018-09-03'),
              list: [
                {
                  isIncome: false,
                  category: 'bill',
                  amount: 115000,
                  label: 'listrik',
                  wallet: 'bca'
                },
                {
                  isIncome: false,
                  category: 'bill',
                  amount: 57550,
                  label: 'air',
                  wallet: 'bca'
                },
                {
                  isIncome: false,
                  category: 'bill',
                  amount: 260000,
                  label: 'internet',
                  wallet: 'bca'
                }
              ]
            },
            {
              date: new Date('2018-09-26'),
              list: [
                {
                  isIncome: false,
                  category: 'grocery',
                  amount: 25000,
                  label: 'beli di alfamart',
                  wallet: 'bca'
                },
                {
                  isIncome: false,
                  category: 'transfer',
                  amount: 100000,
                  label: 'tarik tunai di indomart',
                  wallet: 'bca'
                }
              ]
            },
            {
              date: new Date('2018-09-29'),
              list: []
            }
          ],
          projections: [
            {
              isIncome: true,
              category: 'salary',
              amount: 4000000,
              label: 'gajian',
              date: ''
            },
            {
              isIncome: false,
              category: 'grocery',
              amount: 300000,
              label: 'belanja bulanan',
              date: ''
            },
            {
              isIncome: false,
              category: 'bill',
              amount: 100000,
              label: 'listrik',
              date: ''
            },
            {
              isIncome: false,
              category: 'bill',
              amount: 60000,
              label: 'air',
              date: ''
            },
            {
              isIncome: false,
              category: 'bill',
              amount: 240000,
              label: 'internet',
              date: ''
            },
            {
              isIncome: false,
              category: 'saving',
              amount: 1500000,
              label: 'nabung rumah cash',
              date: ''
            },
            {
              isIncome: false,
              category: 'grocery',
              amount: 250000,
              label: 'alokasi cemilan',
              date: ''
            },
            {
              isIncome: false,
              category: 'grocery',
              amount: 250000,
              label: 'alokasi cemilan',
              date: ''
            },
            {
              isIncome: false,
              category: 'grocery',
              amount: 250000,
              label: 'alokasi cemilan',
              date: ''
            },
            {
              isIncome: false,
              category: 'grocery',
              amount: 250000,
              label: 'alokasi cemilan',
              date: ''
            },
            {
              isIncome: false,
              category: 'grocery',
              amount: 250000,
              label: 'alokasi cemilan',
              date: ''
            },
            {
              isIncome: false,
              category: 'grocery',
              amount: 250000,
              label: 'alokasi cemilan',
              date: ''
            },
            {
              isIncome: false,
              category: 'traveling',
              amount: 1500000,
              label: 'jalan-jalan',
              date: ''
            }
          ]
        }
      }
    };
    console.log(this._data);
    // #endregion

    this.month = moment().format('MMMM');
    this.year = moment().format('YY');
    this.monthyear = this.month + this.year

  }

  // #region: GENERAL
  getTypeList(): any[] {
    return this._typeList;
  }
  // #endregion

  // #region: PROJECTION
  getProjections(month: string = '', year: string = '') {
    // const result = this._data.monthly[month].projections;
    // console.log('getproj', month, year, this.monthyear)
    month == '' ? month = this.month : month = month
    year == '' ? year = this.year : year = year
    // console.log('getproj', month, year, this.monthyear)
    // return result;
    this.budgetApi.find({
      "where": {
        "and": [{
          "date": {
            "gte": moment(year, 'YY').startOf('month').month(month).format()
          }
        }, {
          "date": {
            "lte": moment(year, 'YY').endOf('month').month(month).format()
          }
        }, {
          userid: this.authBudget.getCurrentUserId()
        }]
      },
      "include": ["category","actual"]
    }).subscribe(
      budgetlistmonthyear => {
        this.dataList['projections'][this.monthyear] = budgetlistmonthyear;
        this.events.publish('BUDGET:LOADPROJECTEDSAVING1', budgetlistmonthyear);
      },
      err => {
        // console.log(err)
      }
    )
  }

  addProjection(month: string, data: Projection) {
    console.log('addProjection()', month, data);

    (this._data.monthly[month].projections as any[]).push(data);
  }

  deleteProjection(month: string, index: number) {
    (this._data.monthly[month].projections as any[]).splice(index, 1);
  }
  // #endregion

  // #region: ACTUAL_TRANSACTION
  getActualGroupByDate(month: string = '', year: string = '') {
    month == '' ? month = this.month : month = month
    year == '' ? year = this.year : year = year
    // const result = (this._data.monthly['month0819'] || []).actuals;


    // return result;

    this.actualApi.find({
      "where": {
        "and": [{
          "time": {
            "gte": moment(year, 'YY').startOf('month').month(month).format()
          }
        }, {
          "time": {
            "lte": moment(year, 'YY').endOf('month').month(month).format()
          }
        }, {
          userid: this.authBudget.getCurrentUserId()
        }]
      },
      "include": "category"
    }).subscribe(
      actualList => {
        this.dataList['actuals'][this.monthyear] = actualList[0]['actuals'];
        this.events.publish('BUDGET:LOADACTUALS', actualList[0]);
      }
    )

  }

  getActualGroupByCategory(month: string = '', year: string = '') {
    month == '' ? month = this.month : month = month
    year == '' ? year = this.year : year = year

    this.actualApi.groupByCategory({
      "where": {
        "and": [{
          "time": {
            "gte": moment(year, 'YY').startOf('month').month(month).format()
          }
        }, {
          "time": {
            "lte": moment(year, 'YY').endOf('month').month(month).format()
          }
        }, {
          userid: this.authBudget.getCurrentUserId()
        }]
      },
      "include": "category"
    }).subscribe(data => {
      this.events.publish('BUDGET:LOADACTUALBYCATEGORY', data)
    })
  }

  getActualGroupByBudget(id: number, month: string = '', year: string = '') {
    month == '' ? month = this.month : month = month
    year == '' ? year = this.year : year = year
    this.actualApi.groupByBudget({
      "where": {
        "and": [{
          "time": {
            "gte": moment(year, 'YY').startOf('month').month(month).format()
          }
        }, {
          "time": {
            "lte": moment(year, 'YY').endOf('month').month(month).format()
          }
        }, {
          userid: this.authBudget.getCurrentUserId()
        }, {
          budgetid: id
        }]
      }
    }).subscribe(data => {
      this.events.publish('BUDGET:LOADACTUALBYBUDGET', data)
    })

  }

  addActual(date: Date, data: any) {
    // #note: please strip time from date parameter

    console.log('addActual.date', date);
    const actualList: any[] = this._data.monthly['month08'].actuals;
    const dateIndex = actualList.findIndex(searchItem => {
      console.log(searchItem.date.getDate(), 'compare to', date.getDate());
      if (date.getDate() <= (searchItem.date as Date).getDate()) {
        console.log('result', true);
        return true;
      } else {
        console.log('result', false);
        return false;
      }
    });
    console.log(dateIndex);

    if (dateIndex == -1) {
      // #case1: if no same date found => add data to tail

      // create new dateGroup
      actualList.push({
        date: date,
        list: []
      });

      // add new data
      actualList[actualList.length - 1].list.push(data);
    } else if (actualList[dateIndex].date.getDate() === date.getDate()) {
      // #case2: same date found => direct push
      actualList[dateIndex].list.push(data);
    } else {
      // #case3: if new date should be added before founded date => add data before founded dateIndex

      // create new dateGroup
      actualList.splice(dateIndex, 0, {
        date: date,
        list: []
      });

      // add new data
      actualList[dateIndex].list.push(data);
    }

    // register for later syncronize
    this.addPendingSync(SyncAction.ADD_ACTUAL, data);
  }

  deleteActual(id: number, dateidx: number, listIndex: number) {
    // console.log(
    //   'delete',
    //   this._data.monthly[month].actuals[dateIndex].list,
    //   'at',
    //   listIndex
    // );

    // const thrownData = (this._data.monthly[month].actuals[dateIndex]
    //   .list as any[]).splice(listIndex, 1);
    // // register for later syncronize
    // this.addPendingSync(SyncAction.DELETE_ACTUAL, thrownData);

    // // remove date if record attached
    // if (
    //   (this._data.monthly[month].actuals[dateIndex].list as any[]).length <= 0
    // ) {
    //   (this._data.monthly[month].actuals as any[]).splice(dateIndex, 1);
    // }
    this.dataList['actuals'][this.monthyear][dateidx].list.splice(listIndex, 1);
    this.actualApi.deleteById(id).subscribe()
  }

  unLinkActual(id: number) {
    this.actualApi.updateAll({
      "id": id
    }, {
        "budgetid": null
      }).subscribe()
  }

  linkActuals(): Promise<any> {

    return new Promise((resolve) => {
      this.actualApi.groupByBudget({
        "where": {
          "and": [{ "budgetid": null }, { userid: this.authBudget.getCurrentUserId() }]
        }
      }).subscribe(data => {

        resolve(data);

        // this.events.publish('BUDGET:LOADACTUALBYUNLINK', data)
      })
    });
  }
  // #endregion

  // #region: WALLET
  getWallets(): Observable<any[]> {
    const result = this._data.wallet;

    return result;
  }
  // #endregeion

  // #region: DATA SYNC/UPDATE
  switchWallet() { }

  addPendingSync(action: SyncAction, data: any) {
    switch (action) {
      case SyncAction.ADD_WALLET:
        // scripts
        break;
      case SyncAction.EDIT_WALLET:
        // scripts
        break;
      case SyncAction.DELETE_WALLET:
        // scripts
        break;
      case SyncAction.ADD_ACTUAL:
        // scripts
        break;
      case SyncAction.EDIT_ACTUAL:
        // scripts
        break;
      case SyncAction.DELETE_ACTUAL:
        // scripts
        break;
      case SyncAction.ADD_BUDGET:
        // scripts
        break;
      case SyncAction.EDIT_BUDGET:
        // scripts
        break;
      case SyncAction.DELETE_BUDGET:
        // scripts
        break;
      default:
        console.log('Warning! Unknown sync type', action);
        return;
    }
    console.log('register SyncAction', action, data);
    this.syncBuffer.push({ action, data });
  }
  // #endregion
}

export class Projection {
  isIncome: boolean;
  category: string;
  amount: number;
  label: string;
  date: string;
}

export enum BudgetType {
  INCOME = 2,
  EXPENSE = 1
  // TRANSFER
}

enum SyncAction {
  ADD_WALLET,
  EDIT_WALLET,
  DELETE_WALLET,
  ADD_ACTUAL,
  EDIT_ACTUAL,
  DELETE_ACTUAL,
  ADD_BUDGET,
  EDIT_BUDGET,
  DELETE_BUDGET
}



// WEBPACK FOOTER //
// ./src/providers/sf-budget/sf-budget.ts